import { render } from "./LabsComponent.vue?vue&type=template&id=0d4b2516"
import script from "./LabsComponent.vue?vue&type=script&lang=js"
export * from "./LabsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__